import ForgotPasswordPage from './components/ForgotPasswordPage'

export default ForgotPasswordPage
